import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useRef, useState } from "react";
import { useForm } from "react-hook-form";
// import { Button } from "primereact/button";
import useToastStore from "@/shared/zustand/toastStore";
import Lottie from "react-lottie-player";
import sendDataAnimation from "@/assets/animations/sendDataAnimation.json";
import { useHostMicroFrontendApi } from "@/shared/microfrontend/hooks/useHostMicroFrontend";
import { MF_EVENTS, } from "@/shared/microfrontend/interfaces/microFrontend";
import { config } from "@/config";
import { createClient } from "graphql-ws";
import { v4 as uuidv4 } from "uuid";
import { encodeParam, extractWaitMessage, replaceAsteriskInAnchor, } from "@/shared/utils/helpers";
import ProjectDashboard from "./ProjectDashboard";
import useAuthStore from "@/shared/zustand/authStore";
import useProjectStore from "@/shared/zustand/projectManagementStore";
import ProjectCreationDialog from "./ProjectCreationDialog";
// import { fetchProjectById } from "@/core/api/api";
import { HOST_MODES } from "@/constants";
import { createProject, listProjectsByUser } from "@/core/api/api";
const ProjectCreation = ({ 
// setIsHostLoaded,
setHostLoadedInfo, }) => {
    const dashboardRef = useRef(null);
    const [loading, setLoading] = useState(false);
    const [fetchingProjects, setFetchingProjects] = useState(false);
    const [filtered, setFiltered] = useState(false);
    // const [projects, setProjects] = useState<Project[]>([]);
    const [firstMessageSent, setFirstMessageSent] = useState(false);
    // const [showForm, setShowForm] = useState(false);
    const [replyMessage, setReplyMessage] = useState("");
    const [messageLoading, setMessageLoading] = useState(false);
    const [waitMessageLoading, setWaitMessageLoading] = useState(false);
    const [sessionId, setSessionId] = useState(`chat-session-${uuidv4()}`);
    const [isStreaming, setIsStreaming] = useState(false);
    const [rendordone, setRenderDone] = useState(true);
    const [responseMessages, setResponseMessage] = useState([]);
    const organizationName = "techolution";
    const { setShowForm, setProjects, navigationHistory, setSelectedProject, setShowProjectPage, setNavigationHistory, setAllProjects, } = useProjectStore();
    const loggedInUser = useAuthStore((state) => state.user);
    const { user } = useAuthStore();
    const showToast = useToastStore((state) => state.showToast);
    const fetchProjects = async (showCurrentCreatedProjectId) => {
        try {
            setFetchingProjects(true);
            // old code for api call
            // const response = await axios.get(
            //   process.env.VITE_BASE_API_URL + "/projects"
            // );
            // const { responseData, error } = await getProjects(); // old one
            if (!user || !user.email) {
                console.warn("Dont have user details");
                showToast("warn", "Warn", "Dont have user details");
                return;
            }
            const { responseData, error } = await listProjectsByUser(user.email);
            if (error) {
                console.error("Error fetching projects:", error);
                showToast("error", "Error", error.errorMessage);
                return;
            }
            if (!responseData || !responseData.projects) {
                console.error("Error fetching projects in responseData:", responseData);
                showToast("error", "Error", "Error in fetching projects");
                return;
            }
            if (responseData.projects.length > 0) {
                const resProjects = responseData.projects;
                const filteredProjects = resProjects.filter((project) => !project.hasOwnProperty("parent") || project.parent === "");
                setProjects(filteredProjects);
                setAllProjects(resProjects);
                // to show the project created by the user
                if (showCurrentCreatedProjectId) {
                    const currentCreatedProject = filteredProjects.find((project) => project._id === showCurrentCreatedProjectId);
                    if (currentCreatedProject) {
                        setSelectedProject(currentCreatedProject);
                        setShowProjectPage(true);
                        setNavigationHistory([...navigationHistory, currentCreatedProject]);
                    }
                }
            }
            setFetchingProjects(false);
        }
        catch (error) {
            console.error("Error fetching projects:", error);
            showToast("error", "Error", "Failed to fetch projects");
            setFetchingProjects(false);
        }
    };
    useEffect(() => {
        if (navigationHistory.length === 0)
            fetchProjects();
    }, [navigationHistory]);
    const applyProjectFilter = (projectIds) => {
        // Get latest projects directly from the store
        const latestProjects = useProjectStore.getState().projects;
        // console.log("Latest projects from store:", latestProjects.length);
        if (projectIds.length > 0 && latestProjects.length > 0) {
            setFetchingProjects(true);
            const filteredProjectsById = latestProjects.filter((project) => projectIds.includes(project._id));
            // console.log("Filtered projects:", filteredProjectsById.length);
            if (filteredProjectsById.length > 0) {
                setProjects(filteredProjectsById);
                setFiltered(true);
            }
            setFetchingProjects(false);
        }
    };
    const handleStreamingMessage = async (request) => {
        let client = null;
        try {
            setReplyMessage("");
            const userQuery = request.message;
            // const messageId = request.messageId;
            setMessageLoading(true);
            setWaitMessageLoading(false);
            const requestId = `requestId-${uuidv4()}`;
            const formattedQuery = `User Query: ${userQuery}\n\n Current Mode: Project Creation \n\n`;
            // console.log("formattedQuery", formattedQuery);
            // const userQuestionTime = new Date();
            client = await createClient({
                url: config.VITE_WEBSOCKET_URL ?? "",
            });
            const chatAssistantName = process.env.VITE_PROJECT_CREATION_ASSISTANT_NAME;
            const subscription = client.iterate({
                query: `subscription Subscription($guestSessionId: String!, $sessionId: String!, $name:String!, $organizationName:String!, $aiModel:String!, $prompt:String!, $userName:String!, $userEmailId:String!, $userId:String!, $requestId:String!,$replyMessage:String!,$customPrompt:String, $notificationSessionId:String,$images:String) {
              chatStream(guestSessionId: $guestSessionId, sessionId: $sessionId, name:$name, organizationName:$organizationName, aiModel:$aiModel, prompt:$prompt, userName:$userName, userEmailId:$userEmailId, userId:$userId, requestId:$requestId, replyMessage:$replyMessage, customPrompt:$customPrompt, notificationSessionId:$notificationSessionId,images:$images) {
                continueChatResult {
                      isEnd
                      thinking_break
                      is_orchestrator
                      is_agent
                      responded_by
                      header_message
                      confidenceScore
                      requestId
                      replyMessage
                      sessionId
                      message {
                        citations {
                         citation_number
                          title
                          url
                          description
                          metadata {
                              page_index
                          }
                        }
                        annotations {
                          citations {
                              citation_number
                              title
                              url
                              description
                              metadata {
                                  page_index
                              }
                          }
                          text
                        }
                        citationDisplayType
                        next_query_suggestions {
                          query
                        }
                        response_type
                        content
                        id
                      }
                      resourceId
                    }
                  }
                }`,
                variables: {
                    sessionId: `${organizationName}-${chatAssistantName}-${uuidv4()}`,
                    guestSessionId: `${organizationName}-guest-${uuidv4()}`, //`${user?.email}-${project._id ? project._id : ""}`,
                    name: encodeParam(chatAssistantName),
                    organizationName: encodeParam("techolution"),
                    aiModel: encodeParam("claude-35-sonnet"),
                    prompt: replyMessage === ""
                        ? encodeParam(formattedQuery)
                        : encodeParam(replyMessage + "\n" + formattedQuery),
                    userName: encodeParam(user?.provider?.name), //encodeParam("yash-mathur"),
                    userEmailId: encodeParam(user?.email), //encodeParam("yash.mathur@techolution.com"),
                    userId: encodeParam("0804b20a-2414-40c8-afd1-1bf0703e9d6e"),
                    requestId: encodeParam(requestId),
                    replyMessage: replyMessage,
                    // customPrompt: props?.generatedPrompt,
                    notificationSessionId: sessionId,
                    images: JSON.stringify([]),
                },
            });
            let event;
            const accordianMessageArray = [];
            for await (event of subscription) {
                setIsStreaming(true);
                setRenderDone(false);
                const getAssistantObj = (event, accordianMessageArray) => {
                    const streamedresponse = {
                        role: "assistant",
                        content: "",
                        id: uuidv4(),
                    };
                    //orchestrator is sending message, we initially set it as normal message
                    if (event.data.chatStream.continueChatResult.thinking_break === false &&
                        event.data.chatStream.continueChatResult.is_orchestrator === true &&
                        event.data.chatStream.continueChatResult.isEnd === false) {
                        streamedresponse.content = replaceAsteriskInAnchor(event.data.chatStream.continueChatResult.message.content)?.replace(/WaitMessage: /g, "");
                    }
                    //orchestrator is sending message and thinking break is there, we add it to accordian
                    if (event.data.chatStream.continueChatResult.thinking_break === true &&
                        event.data.chatStream.continueChatResult.is_orchestrator === true &&
                        event.data.chatStream.continueChatResult.isEnd === false) {
                        //check for wait message deletion
                        streamedresponse.content = "";
                        accordianMessageArray.push({
                            responsedata: event.data.chatStream.continueChatResult.message.content,
                            responseFrom: event.data.chatStream.continueChatResult.responded_by,
                            header_message: event.data.chatStream.continueChatResult.header_message,
                            finalResponseStatus: false,
                        });
                    }
                    //orchestrator replied with the final message, this is the final response, no need for accordian
                    if (event.data.chatStream.continueChatResult.thinking_break === false &&
                        event.data.chatStream.continueChatResult.is_orchestrator === true &&
                        event.data.chatStream.continueChatResult.isEnd === true) {
                        streamedresponse.content = replaceAsteriskInAnchor(event.data.chatStream.continueChatResult.message.content)?.replace(/WaitMessage: /g, "");
                    }
                    //agent responded it will directly be shown in collapsed form
                    if (event.data.chatStream.continueChatResult.thinking_break === false &&
                        event.data.chatStream.continueChatResult.is_orchestrator ===
                            false &&
                        event.data.chatStream.continueChatResult.isEnd === false) {
                        accordianMessageArray = [
                            ...accordianMessageArray,
                            {
                                responsedata: event.data.chatStream.continueChatResult.message.content,
                                responseFrom: event.data.chatStream.continueChatResult.responded_by,
                                header_message: event.data.chatStream.continueChatResult.header_message,
                                finalResponseStatus: true,
                            },
                        ];
                    }
                    //final response from agent
                    if (event.data.chatStream.continueChatResult.thinking_break === true &&
                        event.data.chatStream.continueChatResult.is_orchestrator ===
                            false &&
                        event.data.chatStream.continueChatResult.isEnd === false) {
                        accordianMessageArray.push({
                            responsedata: event.data.chatStream.continueChatResult.message.content,
                            responseFrom: event.data.chatStream.continueChatResult.responded_by,
                            header_message: event.data.chatStream.continueChatResult.header_message,
                            finalResponseStatus: false,
                        });
                    }
                    const annotations = event?.data?.chatStream?.continueChatResult?.message?.annotations;
                    let assistantObj = {
                        role: "assistant",
                        content: streamedresponse.content,
                        orchestratorAndAgentsMessages: accordianMessageArray,
                        time: new Date(),
                        requestId: event.data.chatStream.continueChatResult.requestId ?? "",
                        citations: event.data.chatStream.continueChatResult.message.citations,
                        annotations: annotations,
                        resourceId: event.data.chatStream.continueChatResult.resourceId,
                        citationDisplayType: event.data.chatStream.continueChatResult.message
                            .citationDisplayType ?? "",
                        isStreamEnd: false,
                    };
                    if (annotations) {
                        for (let index = 0; index < annotations?.length; index++) {
                            const annotation = annotations[index];
                            assistantObj = {
                                ...assistantObj,
                                content: assistantObj?.content?.replace(annotation?.text, annotation?.text + `<sup>${index}</sup>`),
                            };
                        }
                    }
                    return assistantObj;
                };
                let streamedresponse = { role: "assistant", content: "", id: uuidv4() };
                if (event.data.chatStream.continueChatResult.message.content.includes("WaitMessage: ")) {
                    setMessageLoading(false);
                    setWaitMessageLoading(true);
                    streamedresponse.content = extractWaitMessage(event.data.chatStream.continueChatResult.message.content + "\n\n");
                    //@ts-ignore
                    // !dont know about this case for now
                    const thinkingStatusMessage = {
                        messageType: "loading",
                        message: "",
                        messageId: requestId,
                        time: new Date(),
                        isThinking: true,
                        thinkingResponse: streamedresponse,
                    };
                    // console.log(
                    //   "thinkingStatusMessage in condition which we dont know",
                    //   thinkingStatusMessage
                    // );
                    //   mfApi.dispatch(MF_EVENTS.PROCESS_STATUS, thinkingStatusMessage);
                }
                else {
                    setRenderDone(false);
                    setMessageLoading(false);
                    setWaitMessageLoading(false);
                    streamedresponse.content = replaceAsteriskInAnchor(event.data.chatStream.continueChatResult.message.content)?.replace(/WaitMessage: /g, "");
                    const assistantObject = getAssistantObj(event, accordianMessageArray);
                    try {
                        const parsedContent = JSON.parse(assistantObject.content);
                        // console.log("assistantObject is ", assistantObject);
                        const handleParsedContent = (parsedContent) => {
                            // console.log("parsedContent JSON is ", parsedContent);
                            if ("required" in parsedContent) {
                                if ("name" in parsedContent) {
                                    // console.log("Got the name hurah", parsedContent.name);
                                    setValue("projTitle", parsedContent.name, {
                                        shouldValidate: true,
                                        shouldDirty: true,
                                    });
                                }
                                if ("description" in parsedContent) {
                                    // console.log(
                                    //   "Got the description hurah",
                                    //   parsedContent.description
                                    // );
                                    setValue("projDescription", parsedContent.description, {
                                        shouldValidate: true,
                                        shouldDirty: true,
                                    });
                                }
                                const thinkingStatusMessage = {
                                    messageType: "success",
                                    message: parsedContent.required,
                                    messageId: assistantObject.requestId,
                                    time: new Date(),
                                    isStreamEnd: true,
                                };
                                mfApi.dispatch(MF_EVENTS.PROCESS_STATUS, thinkingStatusMessage);
                                if (!firstMessageSent) {
                                    setFirstMessageSent(true);
                                    setTimeout(() => {
                                        setShowForm(true);
                                    }, 1000);
                                }
                            }
                            else {
                                const thinkingStatusMessage = {
                                    messageType: "error",
                                    message: "Didnt get required fields",
                                    messageId: assistantObject.requestId,
                                    time: new Date(),
                                    isStreamEnd: true,
                                };
                                mfApi.dispatch(MF_EVENTS.PROCESS_STATUS, thinkingStatusMessage);
                            }
                        };
                        handleParsedContent(parsedContent);
                        // original code
                        if ("action" in parsedContent) {
                            if (parsedContent["action"] === "create") {
                                // then its a project creation
                            }
                            else if (parsedContent["action"] === "list") {
                                // then its filtering list
                                setFetchingProjects(true);
                                if ("content" in parsedContent &&
                                    parsedContent["content"] &&
                                    "projects" in parsedContent["content"]) {
                                    const projectIdLists = parsedContent["content"]["projects"];
                                    applyProjectFilter(projectIdLists);
                                }
                                setFetchingProjects(false);
                            }
                        }
                    }
                    catch (error) {
                        console.error("Error parsing assisantObject content:", error);
                    }
                    if (event?.data?.chatStream?.continueChatResult?.isEnd) {
                        try {
                            const parsedWidgetTypeData = JSON.parse(event?.data?.chatStream?.continueChatResult?.message?.content);
                            setIsStreaming(false);
                            if (parsedWidgetTypeData["mode"] === "chat") {
                                setResponseMessage((prev) => [
                                    ...prev,
                                    {
                                        role: "assistant",
                                        content: parsedWidgetTypeData["widget"],
                                    },
                                ]);
                            }
                            else {
                                const parsedWidget = parsedWidgetTypeData["widget"];
                                // console.log("parsedWidget", parsedWidget);
                                //   setIsWidgetTypeChange(true);
                            }
                        }
                        catch (error) {
                            console.error("Error parsing JSON:", error);
                        }
                        break; // this have to know where all the break points are there
                    }
                    // this have to know where all the break points are there
                    // break;
                }
            }
        }
        catch (error) {
            console.error("Error in message processing:", error);
            showToast("error", "Error", "Failed to process message");
            throw error;
        }
        finally {
            if (client) {
                try {
                    const socket = client?.socket;
                    await client.dispose();
                    if (socket) {
                        const socketState = ["CONNECTING", "OPEN", "CLOSING", "CLOSED"][socket.readyState] ||
                            "UNKNOWN";
                        console.log(`WebSocket state after dispose: ${socketState} (${socket.readyState})`);
                        if (socket.readyState === WebSocket.CLOSED) {
                            console.log("WebSocket connection closed successfully");
                        }
                        else {
                            console.warn(`WebSocket not fully closed. Current state: ${socketState}`);
                        }
                    }
                    else {
                        console.log("WebSocket connection disposal completed");
                    }
                }
                catch (error) {
                    console.error("Error during WebSocket cleanup:", error);
                }
            }
            setMessageLoading(false);
            setWaitMessageLoading(false);
        }
    };
    const mfApi = useHostMicroFrontendApi();
    useEffect(() => {
        const handleRemoteLoad = () => {
            console.log("[ProjectCreation] Host component loaded successfully");
            // old code
            // setIsHostLoaded?.(true);
            setHostLoadedInfo({
                modeName: HOST_MODES["Project Mode"],
                isLoaded: true,
            });
            if (mfApi && "setRemoteLoaded" in mfApi) {
                mfApi.setRemoteLoaded(true);
            }
        };
        const handleRemoteUnload = () => {
            console.log("[ProjectCreation] Host component unloaded");
            setHostLoadedInfo({
                modeName: HOST_MODES["Project Mode"],
                isLoaded: false,
            });
            // old code
            // setIsHostLoaded?.(false);
            if (mfApi && "setRemoteLoaded" in mfApi) {
                mfApi.setRemoteLoaded(false);
            }
        };
        handleRemoteLoad();
        return () => {
            handleRemoteUnload();
        };
    }, [mfApi, setHostLoadedInfo]);
    // listening to microfrontend events
    useEffect(() => {
        if (!mfApi) {
            console.warn("Remote MicroFrontend API not initialized");
            return;
        }
        const unsubscribers = [];
        //NOTE: MAKE SURE EVENT NAME IS SAME AS THE `modeName` WHICH IS SET IN THE intialModeList.
        const unsubscribe = mfApi.subscribe(HOST_MODES["Project Mode"], (request) => {
            console.log("Host ProjectCreation received request:", request);
            handleStreamingMessage(request);
        });
        unsubscribers.push(unsubscribe);
        const subModeTriggerInDrive = mfApi.subscribe(MF_EVENTS.TRANSFER_SUBMODE_REQUEST, (request) => {
            console.log("Project Host Mode received TRANSFER_SUBMODE_REQUEST request:", request);
        });
        unsubscribers.push(subModeTriggerInDrive);
        return () => {
            unsubscribers.forEach((unsubscribe) => unsubscribe());
        };
    }, []);
    const { register, handleSubmit, reset, setValue, 
    // watch,
    formState: { errors, isValid }, } = useForm();
    useEffect(() => {
        const handleBeforeUnload = (event) => {
            if (loading) {
                event.preventDefault();
            }
        };
        window.addEventListener("beforeunload", handleBeforeUnload);
        return () => {
            window.removeEventListener("beforeunload", handleBeforeUnload);
        };
    }, [loading]);
    const onSubmit = async (data) => {
        if (loading)
            return;
        try {
            setLoading(true);
            // old code for api call
            // const response = await axios.post(
            //   process.env.VITE_BASE_API_URL + "/projects",
            //   {
            //     user: [loggedInUser?.email],
            //     name: data.projTitle,
            //     description: data.projDescription,
            //   },
            //   {
            //     headers: {
            //       "Content-Type": "application/json",
            //     },
            //   }
            // );
            if (!user || !user.provider.name) {
                console.warn("Dont have user details");
                showToast("warn", "Warn", "Dont have user details");
                return;
            }
            const payload = {
                user: [loggedInUser?.email || ""],
                name: data.projTitle,
                description: data.projDescription || "",
                user_name: user.provider.name,
            };
            const { responseData, error } = await createProject(payload.user, payload.name, payload.description, payload.user_name);
            if (error) {
                console.error("Error creating project:", error);
                showToast("error", "Error", "Failed to create project");
                return;
            }
            if (!responseData) {
                console.error("Error creating project in responseData:", responseData);
                showToast("error", "Error", "Failed to create project");
                return;
            }
            if (responseData) {
                console.log("Project added successfully:", responseData);
                showToast("success", "Success", "Project added successfully");
                reset();
                // Reset the form view and fetch updated projects
                setFirstMessageSent(false);
                setShowForm(false);
                // const { responseData, error } = await fetchProjectById(
                //   response.data?.project_id
                // );
                // console.log("responseData:", responseData);
                // setSelectedProject(responseData);
                // setShowProjectPage(true);
                const userCreatedProjectId = responseData?.project_id;
                await fetchProjects(userCreatedProjectId);
            }
            else {
                console.error("Unexpected response:", responseData);
                showToast("error", "Error", "Unexpected response in project creation");
            }
        }
        catch (error) {
            console.error("Error while sending project data:", error);
            showToast("error", "Error", "There has been an error while sending project data");
        }
        finally {
            setLoading(false);
        }
    };
    // // Watch both form fields
    // const projTitle = watch("projTitle");
    // const projDescription = watch("projDescription");
    // // Auto-submit effect
    // useEffect(() => {
    //   if (projTitle && projDescription && isValid) {
    //     // Small timeout to ensure state updates are complete
    //     const timer = setTimeout(() => {
    //       handleSubmit(onSubmit)();
    //     }, 1000);
    //     return () => clearTimeout(timer);
    //   }
    // }, [projTitle, projDescription, isValid]);
    const handleNewProject = () => {
        setShowForm(true);
        reset(); // Reset the form in case there was any previous data
    };
    const handleProjectSelect = (project) => {
        // console.log("Selected project:", project);
        // setShowProjectPage(true);
        // handleProjectClick(project._id);
        if (mfApi) {
            mfApi.dispatch(MF_EVENTS.PROJECT_STATUS, project);
        }
    };
    const handleClearFilter = async () => {
        setFiltered(false);
        setFetchingProjects(true);
        try {
            await fetchProjects();
        }
        catch (error) {
            console.error("Error fetching projects:", error);
            showToast("error", "Error", "Failed to fetch projects");
        }
        finally {
            setFetchingProjects(false);
        }
    };
    return (_jsxs("div", { className: "w-full h-full bg-white rounded-[8px] font-content shadow-sm ", children: [loading ? (_jsxs("div", { className: "w-full h-full m-auto flex flex-col justify-center items-center p-6", children: [_jsx(Lottie, { animationData: sendDataAnimation, loop: true, play: true, className: "w-full md:w-1/2 mx-auto" }), _jsx("p", { className: "text-lg font-heading", children: "Creating your project" })] })) : (_jsx("div", { className: "w-full h-full", children: _jsx(ProjectDashboard, { fetchingProjects: fetchingProjects, onNewProject: handleNewProject, 
                    // projects={projects}
                    dashboardId: dashboardRef, onProjectSelect: handleProjectSelect, filtered: filtered, onClearFilter: handleClearFilter }) })), _jsx(ProjectCreationDialog, { onSubmit: onSubmit, dashboardRef: dashboardRef, register: register, errors: errors, isValid: isValid, reset: reset, handleSubmit: handleSubmit })] }));
};
export default ProjectCreation;
